
(function ($) {
    $(() => {


        $(".js-search-modal").iziModal({
            width: 470,
            overlay: true,
            overlayClose: true,
            overlayColor: "rgba(0, 0, 0, 0.6)",
            radius: "0"
        });

        $('.js-open-search').on('click', (e) => {
            e.preventDefault();

            $('.js-search-modal').iziModal('open')
            $('#search-input').blur();
        })

        $('#js-search-form').on('submit', function (e) {
            e.preventDefault();
            document.location.href = localize.siteurl + '?s=' + $('#search-input').val();
        })


    });
})(jQuery);
